import { Button, Modal } from "@xola/ui-kit";
import { useCountDown } from "ahooks";
import pluralize from "pluralize";
import React from "react";

interface KeepSessionActiveModalProps {
    deadline: number | null;
    onKeep: () => void;
}

interface KeepSessionActiveBodyProps {
    deadline: number;
    onKeep: () => void;
}

const KeepSessionActiveBody = ({ deadline, onKeep }: KeepSessionActiveBodyProps) => {
    const [msLeft] = useCountDown({ targetDate: deadline, interval: 1000 });
    const secondsLeft = Math.max(0, Math.ceil(msLeft / 1000));

    return (
        <>
            <Modal.Header>Your session is about to expire</Modal.Header>
            <Modal.Body>
                <p>
                    <span className="sm:whitespace-nowrap">
                        For your security, we will automatically log you out in{" "}
                        <span className="whitespace-nowrap">
                            <var data-var="secondsLeft">{secondsLeft}</var> {pluralize("second", secondsLeft)}.
                        </span>
                    </span>
                    <span className="block">Click below to continue working.</span>
                </p>
            </Modal.Body>
            <Modal.Footer>
                {/* Closes this tab's modal at once; other tabs close on their next idle check. */}
                <Button onClick={onKeep}>Stay Logged In</Button>
            </Modal.Footer>
        </>
    );
};

export const KeepSessionActiveModal = ({ deadline, onKeep }: KeepSessionActiveModalProps) => (
    <Modal isOpen={deadline !== null} shouldCloseOnOutsideClick={false}>
        {deadline !== null && <KeepSessionActiveBody deadline={deadline} onKeep={onKeep} />}
    </Modal>
);
